import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

// Media query replicate da @angular/flex-layout (rimosso in Phase 3c).
const FX_MEDIA_QUERIES: { [alias: string]: string } = {
    xs: '(max-width: 599.98px)',
    sm: '(min-width: 600px) and (max-width: 959.98px)',
    md: '(min-width: 960px) and (max-width: 1279.98px)',
    lg: '(min-width: 1280px) and (max-width: 1919.98px)',
    xl: '(min-width: 1920px)',
    'gt-xs': '(min-width: 600px)',
    'gt-sm': '(min-width: 960px)',
    'gt-md': '(min-width: 1280px)',
    'gt-lg': '(min-width: 1920px)',
    'lt-sm': '(max-width: 599.98px)',
    'lt-md': '(max-width: 959.98px)',
    'lt-lg': '(max-width: 1279.98px)',
    'lt-xl': '(max-width: 1919.98px)',
};

// Alias "primari" (mutuamente esclusivi) per determinare il breakpoint attivo emesso su onMediaChange.
const PRIMARY_ALIASES = ['xs', 'sm', 'md', 'lg', 'xl'];

@Injectable({
    providedIn: 'root'
})
export class FuseMatchMediaService
{
    activeMediaQuery: string;
    onMediaChange: BehaviorSubject<string> = new BehaviorSubject<string>('');

    /**
     * Constructor
     *
     * @param {BreakpointObserver} _breakpointObserver
     */
    constructor(
        private _breakpointObserver: BreakpointObserver
    )
    {
        // Set the defaults
        this.activeMediaQuery = '';

        // Initialize
        this._init();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Sostituisce MediaObserver.isActive(alias) di flex-layout.
     */
    isActive(alias: string): boolean
    {
        const query = FX_MEDIA_QUERIES[alias];
        return query ? this._breakpointObserver.isMatched(query) : false;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Initialize
     *
     * @private
     */
    private _init(): void
    {
        const queries = PRIMARY_ALIASES.map(alias => FX_MEDIA_QUERIES[alias]);
        this._breakpointObserver.observe(queries)
            .pipe(
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((state) => {
                const active = PRIMARY_ALIASES.find(alias => state.breakpoints[FX_MEDIA_QUERIES[alias]]);
                const alias = active || '';
                if ( this.activeMediaQuery !== alias )
                {
                    this.activeMediaQuery = alias;
                    this.onMediaChange.next(alias);
                }
            });
    }

}
